import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAssistant, TUser } from '@answerr/types';
import { ToastInfo } from '../types/common.types';

interface CommonState {
  agentInfo: TAssistant | null;
  toastInfo: ToastInfo | null;
  threadId: string;
  shadowColor: string;
  textColor: string;
  linkColor: string;
  questions: string[];
  showSidebar: boolean;
  userInfo?: TUser | null;
}

const initialState: CommonState = {
  agentInfo: null,
  toastInfo: null,
  threadId: '',
  shadowColor: '',
  textColor: '',
  linkColor: '',
  questions: [],
  showSidebar: false,
  userInfo: null,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setAgentInfo: (state, action: PayloadAction<TAssistant | null>) => {
      state.agentInfo = action.payload;
    },
    setToastInfo: (state, action: PayloadAction<ToastInfo | null>) => {
      state.toastInfo = action.payload;
    },
    setThreadId: (state, action: PayloadAction<string>) => {
      state.threadId = action.payload;
    },
    setShadowColor: (state, action: PayloadAction<string>) => {
      state.shadowColor = action.payload;
    },
    setTextColor: (state, action: PayloadAction<string>) => {
      state.textColor = action.payload;
    },
    setLinkColor: (state, action: PayloadAction<string>) => {
      state.linkColor = action.payload;
    },
    setQuestions: (state, action: PayloadAction<string[]>) => {
      state.questions = action.payload;
    },
    setShowSidebar: (state, action: PayloadAction<boolean>) => {
      state.showSidebar = action.payload;
    },
    setUserInfo: (state, action: PayloadAction<TUser | null>) => {
      state.userInfo = action.payload;
    },
  },
});

export const {
  setAgentInfo,
  setToastInfo,
  setThreadId,
  setShadowColor,
  setTextColor,
  setLinkColor,
  setQuestions,
  setShowSidebar,
  setUserInfo,
} = commonSlice.actions;
export default commonSlice.reducer;
